var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 68,
    viewBox: "0 0 60 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10306_114389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.25 2.55026C20.2493 2.55026 11.2999 11.4996 11.2999 22.5003C11.2999 37.4628 28.16 54.2496 31.2293 57.1784C34.2518 54.0359 51.1999 35.8184 51.1999 22.5003C51.1999 11.4996 42.2506 2.55026 31.25 2.55026Z",
    fill: "#168374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9274 22.6659C48.9274 12.9202 40.9962 4.98766 31.2506 4.98732C21.5047 4.98732 13.572 12.92 13.572 22.6659C13.5723 29.3801 17.3996 36.7429 21.8508 42.9697C25.3317 47.8392 29.051 51.8136 31.1772 53.9543C33.2973 51.6552 37.0687 47.3651 40.6002 42.3053C42.8174 39.1287 44.9144 35.6857 46.4525 32.2734C47.9983 28.8438 48.9272 25.559 48.9274 22.6659ZM36.0911 22.6659C36.0911 19.9985 33.9179 17.824 31.2506 17.8236C28.583 17.8236 26.4083 19.9983 26.4083 22.6659C26.4087 25.3332 28.5832 27.5063 31.2506 27.5063C33.9177 27.506 36.0907 25.333 36.0911 22.6659ZM41.0784 22.6659C41.078 28.0865 36.6712 32.4933 31.2506 32.4937C25.8297 32.4937 21.4214 28.0867 21.421 22.6659C21.421 17.2448 25.8295 12.8363 31.2506 12.8363C36.6714 12.8366 41.0784 17.245 41.0784 22.6659ZM53.9147 22.6659C53.9145 26.7364 52.5779 31.0171 50.6769 35.076C48.7672 39.1536 46.2292 43.1302 43.6947 46.6247C38.6262 53.6129 33.4594 58.8244 33.0127 59.2712C32.5299 59.7539 31.8875 59.9998 31.2506 60C30.6536 60 30.0467 59.7843 29.569 59.3482C29.0758 58.9001 23.9047 54.1402 18.8333 47.3732C13.7962 40.6519 8.58497 31.5971 8.58472 22.6659C8.58472 10.1665 18.7512 0 31.2506 0C43.7497 0.000348942 53.9147 10.1667 53.9147 22.6659Z",
    fill: "#51E1CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10306_114389",
    x: -4,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10306_114389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10306_114389",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarker);
export default __webpack_public_path__ + "static/media/ic-marker.d58ee273d4ec16f3e944519e4163e7cf.svg";
export { ForwardRef as ReactComponent };